import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';
import * as yup from 'yup';

export const medicationSummaryValidationSchema = () =>
  createValidationSchema({
    name: commonValidationSchemas.string(),
    manufacturer: yup
      .string()
      .nullable()
      .max(80, 'Manufacturer must be 80 characters or less'),
    otc: commonValidationSchemas.boolean(),
    papAvailable: commonValidationSchemas.boolean(),
    couponDescription: yup
      .string()
      .nullable()
      .max(255, 'Coupon Description must be 255 characters or less'),
  });
